import {
  CONSENT_FORMS_SERVICE,
  ConsentFormsApiService,
  ConsentFormsMockService,
  ConsentTemplatesApiService,
  ConsentTemplatesMockService,
  FORMS_SERVICE,
  FormTemplatesApiService,
  FormTemplatesMockService,
  NOTICE_OF_PRIVACY_PRACTICES_SERVICE,
  NoticeOfPrivacyPracticesApiService,
  NoticeOfPrivacyPracticesMockService,
  SmartFormSubmissionApiService,
  SmartFormSubmissionMockService,
} from '@services';
import {
  CONSENT_TEMPLATES_SERVICE,
  FORM_TEMPLATES_SERVICE,
} from '../tokens/form-templates.token';
import { SMART_FORMS_SERVICE } from '../tokens/smart-forms.token';
import { FormsServiceMock } from '../services/forms/forms.mock.service';
import { FormsServiceApi } from '../services/forms/forms.api.service';
import {
  INTAKE_FORM_TEMPLATE_SERVICE,
  INTAKE_FORMS_SERVICE,
} from '../tokens/intake-forms.token';
import { IntakeFormsApiService } from '../services/intake-forms/intake-forms.api.service';
import { IntakeFormsMockService } from '../services/intake-forms/intake-forms.mock.service';
import { IntakeFormTemplateApiService } from '../services/intake-forms/intake-form-template-api.service';
import { IntakeFormTemplateMockService } from '../services/intake-forms/intake-form-template-mock.service';
import { CONTACT_CHANGE_SERVICE } from '../tokens/contact-change.token';
import { ContactChangeApiService } from '../services/contact-change/contact-change-api.service';
import { ContactChangeMockService } from '../services/contact-change/contact-change-mock.service';
import { PROVIDER_CONTACT_CHANGE_SERVICE } from '../tokens/provider-contact-change.token';
import { ProviderContactChangeApiService } from '../services/provider-contact-change/provider-contact-change-api.service';
import { ProviderContactChangeMockService } from '../services/provider-contact-change/provider-contact-change-mock.service';
import { FULLSCRIPT_SERVICE } from '../tokens/fullscript.token';
import { FullscriptApiService } from '../services/fullscript/fullscript.api.service';
import { FullscriptMockService } from '../services/fullscript/fullscript.mock.service';
import { CHAT_SERVICE } from '../tokens/chat.token';
import { ChatApiService } from '../services/chat/chat-api.service';
import { ChatMockService } from '../services/chat/chat-mock.service';
import { ASK_AI_SERVICE } from '../tokens/ask-ai.token';
import { inject } from '@angular/core';
import { MeService } from '../services/me.service';
import { VOICEMAIL_GATEWAY } from '../services/voicemail/voicemail.gateway';
import { VoicemailApiService } from '../services/voicemail/voicemail.api.service';
import { DemoVoicemailGateway } from '../services/voicemail/voicemail-demo.gateway';
import { VoicemailStore } from '../services/voicemail/voicemail.store';
import { AskAiApiService } from '../services/ask-ai/ask-ai.api.service';
import { AskAiMockService } from '../services/ask-ai/ask-ai.mock.service';
import { FAX_SERVICE } from '../tokens/fax.token';
import { FaxApiService } from '../services/fax/fax.api.service';
import { FaxMockService } from '../services/fax/fax.mock.service';
import { USER_NOTIFICATIONS_SERVICE } from '../tokens/user-notifications.token';
import { UserNotificationsApiService } from '../services/user-notifications/user-notifications.api.service';
import { UserNotificationsMockService } from '../services/user-notifications/user-notifications.mock.service';

export const apiServicesProviders = (useMock = false) => {
  return [
    {
      provide: SMART_FORMS_SERVICE,
      useClass: useMock
        ? SmartFormSubmissionMockService
        : SmartFormSubmissionApiService,
    },
    {
      provide: FORM_TEMPLATES_SERVICE,
      useClass: useMock ? FormTemplatesMockService : FormTemplatesApiService,
    },
    {
      provide: CONSENT_FORMS_SERVICE,
      useClass: useMock ? ConsentFormsMockService : ConsentFormsApiService,
    },
    {
      provide: CONSENT_TEMPLATES_SERVICE,
      useClass: useMock
        ? ConsentTemplatesMockService
        : ConsentTemplatesApiService,
    },
    {
      provide: NOTICE_OF_PRIVACY_PRACTICES_SERVICE,
      useClass: useMock
        ? NoticeOfPrivacyPracticesMockService
        : NoticeOfPrivacyPracticesApiService,
    },
    {
      provide: FORMS_SERVICE,
      useClass: useMock ? FormsServiceMock : FormsServiceApi,
    },
    {
      provide: INTAKE_FORMS_SERVICE,
      useClass: useMock ? IntakeFormsMockService : IntakeFormsApiService,
    },
    {
      provide: INTAKE_FORM_TEMPLATE_SERVICE,
      useClass: useMock
        ? IntakeFormTemplateMockService
        : IntakeFormTemplateApiService,
    },
    {
      provide: CONTACT_CHANGE_SERVICE,
      useClass: useMock ? ContactChangeMockService : ContactChangeApiService,
    },
    {
      provide: PROVIDER_CONTACT_CHANGE_SERVICE,
      useClass: useMock
        ? ProviderContactChangeMockService
        : ProviderContactChangeApiService,
    },
    {
      provide: FULLSCRIPT_SERVICE,
      useClass: useMock ? FullscriptMockService : FullscriptApiService,
    },
    {
      provide: CHAT_SERVICE,
      useClass: useMock ? ChatMockService : ChatApiService,
    },
    {
      provide: ASK_AI_SERVICE,
      useClass: useMock ? AskAiMockService : AskAiApiService,
    },
    {
      provide: FAX_SERVICE,
      useClass: useMock ? FaxMockService : FaxApiService,
    },
    {
      provide: USER_NOTIFICATIONS_SERVICE,
      useClass: useMock
        ? UserNotificationsMockService
        : UserNotificationsApiService,
    },
    {
      provide: VOICEMAIL_GATEWAY,
      // A factory rather than useClass: the demo gateway takes a closure over the signed-in
      // provider's name, which useClass cannot hand a constructor.
      useFactory: () => {
        if (!useMock) return inject(VoicemailApiService);

        const me = inject(MeService);
        return new DemoVoicemailGateway(
          () =>
            [me.me()?.givenName, me.me()?.familyName]
              .filter(Boolean)
              .join(' ') || 'Your practice'
        );
      },
    },
    VoicemailStore,
  ];
};
